"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  CREATE_WORKSPACE_MODAL: null,
  DELETE_WORKSPACE_CONFIRMATION_MODAL: null,
  DELETE_WORKSPACE_MEMBERS_CONFIRMATION_MODAL: null,
  ASSIGN_WORKSPACE_MEMBERS_MODAL: null,
  RENAME_WORKSPACE_MODAL: null
});

exports.default = _default;
module.exports = exports.default;